import bootLayout from 'static/script/app/boot/boot-layout';
import KlarnaSignupUI from 'static/script/app/ui/klarna-signup-ui';
import KlarnaSignupService from 'static/script/app/data/klarna-signup-service';

export default initData => {
    bootLayout(initData);
    KlarnaSignupService.attachTo(document);
    KlarnaSignupUI.attachTo('[data-klarna-signup]');
};


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/pages/klarna-signup.js